<div class="mini-app-bar">
  <a href="/"><img src="assets/images/small-logo.png" /></a>
</div>
<h3>Order Slip</h3>
<h1>#O_{{ orderId$ | async }}</h1>
<h4>{{ ((order$ | async)?.orderCards ?? [])?.length ?? 0 }} Card(s)</h4>
@for (card of (order$ | async)?.orderCards ?? []; track card.id) {
  <p>{{ card.label }}</p>
}
